import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const ContactShow = ({ match }) => {
	const {
		params: { contactID },
	} = match;

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تفاصيل الرسالة",
				breadcrumb: "اتصل بنا",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}contactUs/${contactID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setName(response.data.data.name);
				setEmail(response.data.data.email);
				setPhone(response.data.data.phone);
				setMessage(response.data.data.massage);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				<div className="col-md-12">
					<div className="form-item">
						<label htmlFor="name">الاسم</label>
						<input type="text" id="name" disabled value={name} />
					</div>
					<div className="form-item">
						<label htmlFor="email">البريد الالكتروني</label>
						<input type="email" id="email" disabled value={email} />
					</div>
					<div className="form-item">
						<label htmlFor="phone">رقم الهاتف</label>
						<input type="text" id="phone" disabled value={phone} />
					</div>
					<div className="form-item">
						<label htmlFor="phone">الرسالة</label>
						<textarea
							id="message"
							cols="30"
							rows="5"
							value={message}
							readOnly={true}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ContactShow;
